module.exports = __webpack_public_path__ + "static/media/image-6.8258f5de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-64/image-6.jpg
// module id = 267
// module chunks = 0